import { useState, useEffect, useRef } from 'react';
import Dropdown from './Dropdown';
import { NavLink, useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { ArrowForwardIos, Delete } from '@mui/icons-material';
import { Button, Icon } from '@mui/material';
import { getTransactionList } from "../api/transaction-list";
import { createSlug } from "../config/slug-config";
import { useSelector } from 'react-redux';

const MenuItems = ({ items, depthLevel, to }) => {
  const [dropdown, setDropdown] = useState(false);
  let ref = useRef();
  const { data: user } = useSelector((state) => state.user);
  const [pages,setPages]=useState([])

  useEffect(() => {
    if (user.token) {
      setPages(JSON.parse(user?.page_access?.replace("{","[").replace("}","]")))
    }
  }, [user.token]);

  useEffect(() => {
    const handler = (event) => {
      if (
        dropdown &&
        ref.current &&
        !ref.current.contains(event.target)
      ) {
        setDropdown(false);
      }
    };
    document.addEventListener('mousedown', handler);
    document.addEventListener('touchstart', handler);
    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', handler);
      document.removeEventListener('touchstart', handler);
    };
  }, [dropdown]);

  const onMouseEnter = () => {
    window.innerWidth > 960 && setDropdown(true);
  };

  const onMouseLeave = () => {
    window.innerWidth > 960 && setDropdown(false);
  };

  const closeDropdown = () => {
    dropdown && setDropdown(false);
  };
  const location = useLocation()
  return (
    <li
      className="menu-items"
      selected={to === location.pathname}

      ref={ref}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={closeDropdown}
    >
      {items.url && items.submenu ? (
        <>
          <button
            type="button"
            aria-haspopup="menu"
            aria-expanded={dropdown ? 'true' : 'false'}
            onClick={() => setDropdown((prev) => !prev)}
          >
            {window.innerWidth < 960 && depthLevel === 0 ? (
              items.title
            ) : (
              <Link to={items.url} >{items.title}</Link>
            )}

            {depthLevel > 0 &&
              window.innerWidth < 960 ? null : depthLevel > 0 &&
                window.innerWidth > 960 ? (
              <span>&raquo;</span>
            ) : (
              <span className="arrow" />
            )}
          </button>
          <Dropdown
            depthLevel={depthLevel}
            submenus={items.submenu}
            dropdown={dropdown}
          />
        </>
      ) : !items.url && items.submenu ? 
      (
        user.role === "admin"|| user.role === "user" 
        ?
        <>
        <Button
          type="button"
          aria-haspopup="menu"
          className='menu-button-text'
          aria-expanded={dropdown ? 'true' : 'false'}
          onClick={() => setDropdown((prev) => !prev)}
         // startIcon={<Icon className='mr-1'>{items.icon}</Icon>}
        >
           <Icon className='drowdown-menu-icon mr-1'>{items.icon}</Icon> 
          <div className='drowdown-menu-width'>
          <span className='f-left '>{items.title}{' '} </span>           
          {depthLevel > 0 ? (
            <span className='f-right'> <ArrowForwardIos sx={{ fontSize: 20 }} /> </span>
          ) : (
            <span className="arrow" />
          )}
          </div>
        </Button>
        <Dropdown
          depthLevel={depthLevel}
          submenus={items.submenu}
          dropdown={dropdown}
        />
      </>
        :
        pages ? 
          items?.submenu.map((el)=> pages?.some(keyword => el?.url?.replace("transaction-type/" ,"") === createSlug(keyword))).some(el=>el === true)  || items.title ==="Transactions"
         ?

      //  items.url === "/dashboard"|| items.url === "/transaction-list"  ||items.url === "/accounts" || items.url.includes(createSlug(rowData.fullname))  ?
      <>
          <Button
            type="button"
            aria-haspopup="menu"
            className='menu-button-text'
            aria-expanded={dropdown ? 'true' : 'false'}
            onClick={() => setDropdown((prev) => !prev)}
           // startIcon={<Icon className='mr-1'>{items.icon}</Icon>}
          >
             <Icon className='drowdown-menu-icon mr-1'>{items.icon}</Icon> 
            <div className='drowdown-menu-width'>
            <span className='f-left '>{items.title}{' '} </span>           
            {depthLevel > 0 ? (
              <span className='f-right'> <ArrowForwardIos sx={{ fontSize: 20 }} /> </span>
            ) : (
              <span className="arrow" />
            )}
            </div>
          </Button>
          <Dropdown
            depthLevel={depthLevel}
            submenus={items.submenu}
            dropdown={dropdown}
          />
        </> 
      :
       null
      // null
    :null
       )
      
      : 
      (
        user.role === "admin"|| user.role === "user" 
        ?
        <NavLink to={items.url} className='a-Menu-link' activeclassname="active"><Icon className='mr-1'>{items.icon}</Icon>{items.title}</NavLink>
 
        :
        pages ? 

        // items.url === "/transaction-list"   || pages?.some(keyword => items.url.includes(createSlug(keyword)))?
        items.url === "/transaction-list" || pages?.some(keyword => items.url.replace("transaction-type/" ,"") === createSlug(keyword)) || items.url === "/fileCabinet" || items.url === "/reports" || items.url === "/lists" || items.url === "/saved-search" || items.url === "/amortization-reports" || items.url === "/transaction-total" || items.url === "/all-transactions" ?
      //  items.url === "/dashboard"|| items.url === "/transaction-list"  ||items.url === "/accounts" || items.url.includes(createSlug(rowData.fullname))  ?

        <NavLink to={items.url} className='a-Menu-link' activeclassname="active"><Icon className='mr-1'>{items.icon}</Icon>{items.title}</NavLink>
      
      :
       null
       :
       null
       )
       }
    </li>
  );
};

export default MenuItems;
